











































































import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref,
  useStore,
  watch,
} from '@nuxtjs/composition-api'
import HeaderNextButton from './HeaderNextButton.vue'
import HeaderNextMobileButtons from './HeaderNextMobileButtons.vue'
import {
  getModalKey,
  HeaderModalKey,
  HeaderNextButtonData,
  isAccentLabel,
} from './helpers'
import MenuLogotype from '@/components/Header/MenuLogotype.vue'

const MOBILE_QUERY = '(max-width: 1023px)'
const MODAL_IDS: Record<HeaderModalKey, string> = {
  navigation: 'modal-navigation',
  'auth-account': 'modal-auth-account',
}
const COVER_OVERLAP = 2
const COVER_VAR = '--header-next-cover'
// то же условие, что в @supports стилей: без animation-range поддержка неполная
const SCROLL_TIMELINE_QUERY =
  '(animation-timeline: scroll()) and (animation-range: 0% 100%)'

const supportsScrollTimeline = (): boolean =>
  typeof CSS !== 'undefined' &&
  typeof CSS.supports === 'function' &&
  CSS.supports(SCROLL_TIMELINE_QUERY)

export default defineComponent({
  name: 'HeaderNextMenu',
  components: { HeaderNextButton, HeaderNextMobileButtons, MenuLogotype },
  props: {
    leftList: {
      type: Array as PropType<HeaderNextButtonData[]>,
      default: () => [],
    },
    rightList: {
      type: Array as PropType<HeaderNextButtonData[]>,
      default: () => [],
    },
    mobileList: {
      type: Array as PropType<HeaderNextButtonData[]>,
      default: () => [],
    },
    logotype: { type: Object, default: () => ({}) },
  },
  setup(props, { emit }) {
    const store = useStore()
    const root = ref<HTMLElement | null>(null)
    const main = ref<HTMLElement | null>(null)
    const ribbon = ref<{ $el: HTMLElement } | null>(null)
    const isMobile = ref(false)

    const menuButton = computed(() => props.leftList[0])
    const restLeftButtons = computed(() => props.leftList.slice(1))
    const authButton = computed(
      () => props.rightList[props.rightList.length - 1]
    )
    const restRightButtons = computed(() => props.rightList.slice(0, -1))

    const menuModalKey = computed(() =>
      getModalKey(menuButton.value?.url ?? '')
    )
    const authModalKey = computed(() =>
      getModalKey(authButton.value?.url ?? '')
    )

    const openModal = (key: HeaderModalKey | null): void => {
      if (key) store.commit('modal/SET_MODAL', MODAL_IDS[key])
    }

    const getRibbonEl = (): HTMLElement | null => ribbon.value?.$el ?? null

    const getCoverDistance = (ribbonEl: HTMLElement): number =>
      Math.max(ribbonEl.offsetHeight - COVER_OVERLAP, 0)

    const updateOffset = (): void => {
      const mainEl = main.value
      const ribbonEl = getRibbonEl()

      if (!mainEl || !ribbonEl) return

      const offset = Math.min(
        Math.max(window.scrollY, 0),
        getCoverDistance(ribbonEl)
      )

      mainEl.style.transform = `translateY(${-offset}px)`
    }

    const updateCoverDistance = (): void => {
      const rootEl = root.value
      const ribbonEl = getRibbonEl()

      if (!rootEl || !ribbonEl) return

      rootEl.style.setProperty(COVER_VAR, `${getCoverDistance(ribbonEl)}px`)
    }

    let useScrollTimeline = false

    const syncCover = (): void => {
      if (!isMobile.value) return

      if (useScrollTimeline) updateCoverDistance()
      else updateOffset()
    }

    const emitHeight = (): void => {
      const mainEl = main.value
      const rootEl = root.value

      if (!mainEl || !rootEl) return

      const height = isMobile.value
        ? (getRibbonEl()?.offsetHeight ?? 0) + mainEl.offsetHeight
        : rootEl.offsetHeight

      emit('height', height)
    }

    let frameId = 0
    const onScroll = (): void => {
      if (frameId) return

      frameId = requestAnimationFrame(() => {
        updateOffset()
        frameId = 0
      })
    }

    const stopScroll = (): void => {
      window.removeEventListener('scroll', onScroll)
      cancelAnimationFrame(frameId)
      frameId = 0

      if (main.value) main.value.style.transform = ''
    }

    const startScroll = (): void => {
      syncCover()

      if (!useScrollTimeline) {
        window.addEventListener('scroll', onScroll, { passive: true })
      }
    }

    const onResize = (): void => {
      syncCover()
      emitHeight()
    }

    let mediaQuery: MediaQueryList | null = null
    let resizeObserver: ResizeObserver | null = null

    const onMediaChange = (): void => {
      isMobile.value = !!mediaQuery?.matches
    }

    watch(isMobile, (value) => {
      stopScroll()
      if (value) startScroll()
      emitHeight()
    })

    watch(
      () => props.mobileList.length,
      () => {
        stopScroll()
        if (isMobile.value) startScroll()
      },
      { flush: 'post' }
    )

    onMounted(() => {
      useScrollTimeline = supportsScrollTimeline()

      mediaQuery = window.matchMedia(MOBILE_QUERY)
      mediaQuery.addEventListener('change', onMediaChange)
      onMediaChange()

      if (typeof ResizeObserver !== 'undefined') {
        resizeObserver = new ResizeObserver(onResize)
        if (root.value) resizeObserver.observe(root.value)
        if (main.value) resizeObserver.observe(main.value)
      }

      emitHeight()
    })

    onBeforeUnmount(() => {
      stopScroll()
      mediaQuery?.removeEventListener('change', onMediaChange)
      resizeObserver?.disconnect()
    })

    return {
      root,
      main,
      ribbon,
      menuButton,
      restLeftButtons,
      authButton,
      restRightButtons,
      menuModalKey,
      authModalKey,
      openModal,
      isAccent: isAccentLabel,
    }
  },
})
